import { RESOURCE_NAMES, type ResourceCost } from '@kaeliux/shared';
import { formatCompactNumber, formatFullNumber } from '../utils/formatters';
import { RESOURCE_ORDER, resourceCostGlyph } from './resourceCostIcons';

interface ResourceCostListProps {
    cost: ResourceCost;
    label?: string;
}

/**
 * Vertical list of resource swatch + amount rows, used beside a
 * building/ship thumbnail — mirrors the swatch-plus-amount shape used by the
 * surface's cost popovers so a cost reads identically wherever it appears.
 */
export default function ResourceCostList({ cost, label }: ResourceCostListProps) {
    const rows = RESOURCE_ORDER.filter((key) => cost[key]);

    return (
        <div className="flex flex-col justify-center gap-1 min-w-[5.5rem]">
            {label && <span className="text-micro text-content-muted uppercase tracking-wide">{label}</span>}
            {rows.length === 0 ? (
                <span className="text-micro text-content-muted">—</span>
            ) : (
                <ul className="flex flex-col gap-1 text-value text-content-secondary">
                    {rows.map((key) => (
                        <li
                            key={key}
                            className="flex items-center gap-1.5 whitespace-nowrap"
                            title={`${formatFullNumber(cost[key] ?? 0)} ${RESOURCE_NAMES[key]}`}
                        >
                            {resourceCostGlyph(key)}
                            <span>{formatCompactNumber(cost[key] ?? 0)}</span>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
}
